export const LINKS = [
  {
    name: "KuCoin",
    href: "https://www.kucoin.com/trade/RARI-USDT",
  },
  {
    name: "Relay",
    href: "https://relay.link/bridge/ethereum?fromChainId=1&fromCurrency=0x0000000000000000000000000000000000000000&toCurrency=0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
  },
  {
    name: "Uniswap",
    href: "https://app.uniswap.org/explore/tokens/ethereum/0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
  },
  {
    name: "Coinbase",
    href: "https://exchange.coinbase.com/trade/RARI-USD",
  },
  {
    name: "MEXC",
    href: "https://www.mexc.com/exchange/RARI_USDT",
  },
  {
    name: "Kraken Pro",
    href: "https://pro.kraken.com/app/trade/rari-usd",
  },
  {
    name: "Gate",
    href: "https://www.gate.com/trade/RARI_USDT",
  },
  {
    name: "CoinMarketCap",
    href: "https://coinmarketcap.com/currencies/rarible/",
  },
]
